<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="toc">
<section epub:type="division">
<p class="c12"><a id="page_v"></a><strong class="calibre1">CONTENTS</strong></p>
<p class="c13"><a class="calibre5" href="#/text/part0005#page_vii">General editors' preface</a></p>
<p class="c13"><a class="calibre5" href="#/text/part0006#page_ix">Acknowledgements</a></p>
<p class="c13"><a class="calibre5" href="#/text/part0007#page_xi">Chronology</a></p>
<p class="c13"><a class="calibre5" href="#/text/part0008#page_xvi">Cue-titles</a></p>
<p class="c13"><a class="calibre5" href="#/text/part0009#page_xix">Introduction</a></p>
<p class="c14"><em class="calibre4"><a class="calibre5" href="#/text/part0010#id_307">Sketches of Etruscan Places</a></em></p>
<p class="c14"><a class="calibre5" href="#/text/part0010#page_liv">Italian Essays, 1919–27</a></p>
<p class="c13"><em class="calibre4"><span class="calibre5" href="#/text/part0011#page_1" title="Link target outside of Sample">SKETCHES OF ETRUSCAN PLACES</span></em></p>
<p class="c14"><span class="calibre5" href="#/text/part0014#page_7" title="Link target outside of Sample">I.       Cerveteri</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0016#page_23" title="Link target outside of Sample">II.     Tarquinia</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0018#page_41" title="Link target outside of Sample">III.    The Painted Tombs of Tarquinia 1</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0022#page_113" title="Link target outside of Sample">IV.     The Painted Tombs of Tarquinia 2</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0024#page_135" title="Link target outside of Sample">V.      Vulci</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0026#page_155" title="Link target outside of Sample">VI.     Volterra</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0028#page_173" title="Link target outside of Sample">VII.   The Florence Museum</span></p>
<p class="c14"><em class="calibre4"><span class="calibre5" href="#/text/part0020#page_65" title="Link target outside of Sample">Illustrations</span></em></p>
<p class="c13"><span class="calibre5" href="#/text/part0030#page_181" title="Link target outside of Sample">ITALIAN ESSAYS, 1919–27</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0032#page_183" title="Link target outside of Sample">David</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0034#page_191" title="Link target outside of Sample">Looking Down on the City</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0037#page_197" title="Link target outside of Sample">Europe Versus America</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0039#page_201" title="Link target outside of Sample">Fireworks</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0042#page_209" title="Link target outside of Sample">The Nightingale</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0045#page_217" title="Link target outside of Sample">Man is a Hunter</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0047#page_223" title="Link target outside of Sample">Flowery Tuscany</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0050#page_245" title="Link target outside of Sample">Germans and English</span></p>
<p class="c13"><span class="calibre5" href="#/text/part0052#page_253" title="Link target outside of Sample">Appendixes <em class="calibre4">Sketches of Etruscan Places</em></span></p>
<p class="c14"><span class="calibre5" href="#/text/part0052#id_308" title="Link target outside of Sample">I 'The Painted Tombs of Tarquinia', First version</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0055#page_267" title="Link target outside of Sample">II Historical outline</span></p>
<p class="c14"><span class="calibre5" href="#/text/part0057#page_273" title="Link target outside of Sample">III Photographs</span></p>
<p class="c13"><span class="calibre5" href="#/text/part0059#page_279" title="Link target outside of Sample">Appendix IV Maps</span></p>
<p class="c13"><span class="calibre5" href="#/text/part0061#page_285" title="Link target outside of Sample">Appendix V 'Fireworks' [Fireworks in Florence]</span></p>
<p class="c13"><span class="calibre5" href="#/text/part0064#page_293" title="Link target outside of Sample">Explanatory notes</span></p>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0004.vue?10475cb3